import { createServerFn } from "@tanstack/solid-start";
import { z } from "zod";
import { withSentrySpan } from "~/lib/sentry-span";
import { authFunctionMiddleware } from "~/server/middleware/auth";

export const GetVendorsPageDataInputSchema = z.object({
  businessId: z.string().trim().min(1),
});

/**
 * Aggregate server function for the vendors index page.
 *
 * Fetches vendors list and business detail in a single HTTP round trip
 * on client-side navigation.
 */
export const getVendorsPageData = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .validator((i: unknown) => GetVendorsPageDataInputSchema.parse(i))
  .handler(async ({ context, data }) => {
    return withSentrySpan("vendors.pageData", async () => {
      const [businessMod, vendorMod] = await Promise.all([
        import("../business/business.server"),
        import("./vendor.server"),
      ]);
      const { getBusinessDetailForUser } = businessMod;
      const { listVendorsForUser } = vendorMod;

      const [businessDetail, vendors] = await Promise.all([
        getBusinessDetailForUser(context.user.id, data.businessId),
        listVendorsForUser(context.user.id, data.businessId, {
          limit: 20,
        }),
      ]);

      return { businessDetail, vendors } as const;
    });
  });
